import AccommodationIndividualSelectRoomOptionTile from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptionTile'
import AccommodationIndividualSelectRoomOptionTileCTA from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptionTileCTA'
import AccommodationIndividualSelectRoomOptionTileDetails from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptionTileDetails'
import TextButton from 'LuxKit/Button/TextButton'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { useIntl } from 'react-intl'

import PropertyRateInclusions from './PropertyRateInclusions'
import { isPropertyInclusionValidForDuration } from './singlePropertyUtils'

interface Props {
  propertyRoom: App.Property.Room
  isSelected: boolean
  optionVariant: 'stacked' | 'carousel'
  duration: number
  property: App.Property.Property
  onSelect: () => void
}

/**
 * The room-only option shown before dates are picked, when there is no rate to price or cancel.
 * Split out of PropertyIndividualRoomSelectRoomOption so anytime concerns, chiefly filtering room
 * inclusions by duration, live here and the rated tile can treat its rate as present. Mirrors the
 * PropertyRateOption and PropertyAnytimeRateOption pair.
 */
function PropertyIndividualRoomAnytimeRateOption(props: Props) {
  const {
    propertyRoom,
    isSelected,
    optionVariant,
    duration,
    property,
    onSelect,
  } = props
  const intl = useIntl()

  const [inclusions, bonusInclusions, luxPlusInclusions, bundleInclusions] = [
    propertyRoom.inclusions.filter(inclusion => isPropertyInclusionValidForDuration(inclusion, duration)),
    propertyRoom.bonusInclusions.filter(inclusion => isPropertyInclusionValidForDuration(inclusion, duration)),
    propertyRoom.luxPlusInclusions.filter(inclusion => isPropertyInclusionValidForDuration(inclusion, duration)),
    propertyRoom.bundleInclusions.filter(inclusion => isPropertyInclusionValidForDuration(inclusion, duration)),
  ]
  const showInclusions = (
    inclusions.length > 0 ||
    bonusInclusions.length > 0 ||
    luxPlusInclusions.length > 0 ||
    bundleInclusions.length > 0
  )

  return (
    <AccommodationIndividualSelectRoomOptionTile isSelected={isSelected}>
      <AccommodationIndividualSelectRoomOptionTileDetails variant={optionVariant}>
        {showInclusions && <PropertyRateInclusions
          property={property}
          inclusions={inclusions}
          bonusInclusions={bonusInclusions}
          luxPlusInclusions={luxPlusInclusions}
          bundleInclusions={bundleInclusions}
          maxHeight={208}
        />}
      </AccommodationIndividualSelectRoomOptionTileDetails>
      <AccommodationIndividualSelectRoomOptionTileCTA>
        {isSelected && <TextButton kind="primary" startIcon={<LineCheckIcon />} nonInteractable>
          {intl.formatMessage({
            id: '1IRx8lbZVkU7PYtgPvtT',
            defaultMessage: 'Selected',
          })}
        </TextButton>}
        {!isSelected && <TextButton kind="secondary" onClick={onSelect}>
          {intl.formatMessage({
            id: 'p_umY21zQsl1hqz1rtlE',
            defaultMessage: 'Select',
          })}
        </TextButton>}
      </AccommodationIndividualSelectRoomOptionTileCTA>
    </AccommodationIndividualSelectRoomOptionTile>
  )
}

export default withOfferPageState((state) => ({
  property: state.property!, // Guaranteed by `<PropertyContainer/>`.
}), PropertyIndividualRoomAnytimeRateOption)
